import { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import ContainsEquipment from './ContainsEquipment';
import ContainsLocations from './ContainsLocations';

const LocationDetails = ({ building, loc, stagingEquipment }) => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs value={tab} onChange={(event, newValue) => setTab(newValue)}>
        <Tab className="tab" label="Contains Equipment" />
        <Tab className="tab" label="Contains Locations" />
      </Tabs>
      {tab === 0 ? (
        <ContainsEquipment building={building} loc={loc} stagingEquipment={stagingEquipment} />
      ) : null}
      {tab === 1 ? <ContainsLocations building={building} loc={loc} /> : null}
    </>
  );
};

export default LocationDetails;
